import React, { useContext, useState, useEffect} from 'react'
import { connect } from 'react-redux'
import { Loader } from 'semantic-ui-react'
import { doTokenLogin } from '../../actions/actionCreators'
import { Text } from '../../helpers/language';

const SubscriptionManage = (props) => {
  const {id, token} = props.match.params

  const [posted, setPosted] = useState(false);
  const [dispatched, setDispatched] = useState(false);

  useEffect(() => {
    if (!posted) {
      setPosted(true); 
      props.dispatch(doTokenLogin({id: id, token: token })).then(() => {
        setDispatched(true);          
      } )
    } 
    if (dispatched) {
      if (props.auth.isLogged)
        props.history.push('/subscription')
      else
        props.history.push('/login') 
    }
  })
    
  return (      
      <Loader size='large' active > <Text tid ='loading'/> </Loader>      
  )

}

const mapStateToProps = (state) => ({
  auth: state.auth,
  passwordRestore: state.passwordRestore
})

export default connect(mapStateToProps)(SubscriptionManage)
